import API from "../services/api";
import config from "../config";
import { Toast } from "../shared/Toast";
import { differenceInDays } from "date-fns";
import { formatDateWithTime } from "./dateFormat";
export const languageOptions = [
  { value: 1, label: "Telugu" },
  { value: 2, label: "Tamil" },
  { value: 3, label: "Hindi" },
  { value: 4, label: "Kannada" },
  { value: 6, label: "Marathi" },
  { value: 7, label: "Bengali" },
  { value: 5, label: "Malayalam" },
  { value: 8, label: "Gujarati" },
  { value: 9, label: "Punjabi" },
  { value: 10, label: "Oria" },
  { value: 11, label: "English" },
  { value: 13, label: "Telugu-English"}
];
export const langoptions_preview = [
  "",
  "Telugu",
  "Tamil",
  "Hindi",
  "Kannada",
  "Malayalam",
  "Marathi",
  "Bengali",
  "Gujarati",
  "Punjabi",
  "Odia",
  "English",
  "",
  "Telugu-English"
];

export const updateBlockerFlag = async (campaign_id, flag) => {
  const updateAdminFlag = await API({
    url: "lineitems/updateBlocker", // which also set admin value to scheduled edit
    responseType: "json",
    data: { campaign_id: campaign_id, flag: flag },
    method: "POST",
  });
};
export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const dfpBackfillAdTypes = [
  { lable: "GAM", value: "google" },
  { lable: "MagicBid", value: "mbid" },
  // {lable: "Direct-Nimbus", value: 'dir_nmb'},
  // {lable: "GAM-Nimbus", value: 'dfp_gm_nmb'},
  { lable: "GAM-Amazon", value: "dfp_gm_amz" },
  // {lable: "GAM-Amazon-Nimbus", value: 'dfp_gm_amz_nmb'},
  // {lable: "GAM-Amazon+Nimbus", value: 'dfp_gm_amz_nmb1'},
  { lable: "VDO", value: "vdo" },
  { lable: "Native-Banner", value: "dfp_nativebanner" },
];

export function formatSpentValue(value) {
  if (!value) return value;
  if (value < 1000) {
    return `${value}`;
  } else if (value >= 1000 && value < 1000000) {
    const kValue = (value / 1000).toFixed(2);
    return `${kValue}K`;
  } else if (value >= 1000000) {
    const mValue = (value / 1000000).toFixed(2);
    return `${mValue}M`;
  } else return 0;
}

export function formatAmount(amount) {
  // if (isNaN(amount) || amount === undefined || amount === null) {
  //   return 0;
  // }
  // if (amount >= 10000000) {
  //   return (amount / 10000000).toFixed(3) + " Cr";
  // } else {
  //   return (amount / 100000).toFixed(3) + " L";
  // }

  if (!isFinite(amount) || amount === 0) {
    return 0;
  }

  let absAmount = Math.abs(amount);
  let formattedAmount;
  let unit;
  if(absAmount < 1000){
    return parseInt(absAmount)
  }
  else if (absAmount <= 10000) {
    formattedAmount = (absAmount / 1000).toFixed(2);
    unit = "k";
  } else if (absAmount >= 10000000) {
    // 1 crore = 10,000,000
    formattedAmount = (absAmount / 10000000).toFixed(2);
    unit = "Cr";
  } else {
    // 1 lakh = 100,000
    formattedAmount = (absAmount / 100000).toFixed(2);
    unit = "L";
  }

  // Preserve the sign
  return ((amount < 0 ? "-" : "") + formattedAmount + " " + unit);
}

export const removeCommonLocation = (
  lang_ids,
  state_ids,
  district_ids,
  mandal_ids,
  village_ids,
  exclude
) => {
  return new Promise((resolve, reject) => {
    try {
      let mandalRes = [],
        districtRes = [],
        statesRes = [],
        villageRes = [],
        mandaldum = [],
        districtdum = [],
        statedum = [],
        langdum = [];
      let ex_villages = [],
        ex_mandals = [],
        ex_districts = [],
        states = [],
        mandalsinlist = [],
        districtinlist = [],
        statesinlist = [],
        villagesinlist = [];
      if (mandal_ids.length)
        mandalsinlist = mandal_ids.map((j) => +j.mandal_id);
      if (district_ids.length)
        districtinlist = district_ids.map((j) => +j.dist_id);
      if (state_ids.length) statesinlist = state_ids.map((j) => +j.state_id);
      if (village_ids.length)
        villagesinlist = village_ids.map((j) => +j.village_id);
      if (village_ids.length) mandaldum = village_ids.map((j) => +j.mandal_id);
      if (mandal_ids.length) districtdum = mandal_ids.map((j) => +j.dist_id);
      if (district_ids) statedum = district_ids.map((j) => +j.state_id);
      if (state_ids) langdum = state_ids.map((j) => +j.lang_id);
      if (exclude) {
        if (village_ids.length) {
          ex_villages = villagesinlist;
          mandalRes = mandaldum;
          villageRes = [];
        }
        if (mandal_ids.length) {
          ex_mandals = mandalsinlist.filter(
            (item) => !mandaldum.includes(item)
          );
          districtRes = [];
          mandal_ids.map((item) => {
            if (ex_mandals.includes(item.mandal_id))
              districtRes.push(+item.dist_id);
          });
        }
        if (district_ids.length) {
          ex_districts = districtinlist.filter(
            (item) => !districtdum.includes(+item)
          );
          statesRes = [];
          district_ids.map((item) => {
            if (ex_districts.includes(+item.dist_id))
              statesRes.push(+item.state_id);
          });
          let tempStates = statesinlist.filter(
            (item) => !statedum.includes(item)
          );
          statesRes = [...new Set([...statesRes, ...tempStates])];
        } else {
          statesRes = statesinlist;
        }
        // statesRes = statesinlist
      } else {
        villageRes = villagesinlist;
        statesRes = statesinlist.filter((item) => !statedum.includes(item));
        mandalRes = mandalsinlist.filter((item) => !mandaldum.includes(item));
        districtRes = districtinlist.filter(
          (item) => !districtdum.includes(item)
        );
      }
      lang_ids = lang_ids.filter((item) => !langdum.includes(item));

      statesRes = Array.from(new Set(statesRes));
      districtRes = Array.from(new Set(districtRes));
      mandalRes = Array.from(new Set(mandalRes));
      villageRes = Array.from(new Set(villageRes));
      ex_districts = Array.from(new Set(ex_districts));
      ex_mandals = Array.from(new Set(ex_mandals));
      ex_villages = Array.from(new Set(ex_villages));
      return resolve({
        lang_ids,
        state_ids: statesRes,
        district_ids: districtRes,
        mandal_ids: mandalRes,
        village_ids: villageRes,
        ex_villages,
        ex_mandals,
        ex_districts,
      });
    } catch (error) {
      console.error(error);
    }
  });
};

export const localRegions = [
  { label: "Legal", value: -1, main_value: "legal" },
  { label: "Others", value: 0, main_value: "others" },
  { label: "All districts", value: 1, main_value: "all_districts" },
  { label: "Metro", value: 2, main_value: "metro" },
  { label: "Tamil Nadu Sales", value: 3, main_value: "tamilnadusales" },
  { label: "Alpha", value: 4, main_value: "alpha" },
];
export const roles = {
  advertiser: "w@y2n3m$Ad$-ADV",
  financer: "w@y2n3m$Ad$-FIN",
  ops: "w@y2n3m$Ad$-OPS",
  salesperson: "w@y2n3m$Ad$-SLS",
  network_ad_manager: "w@y2n3m$Ad$-NAM",
  b2b: "w@y2n3m$Ad$-B2B",
  designer:'w@y2n3m$Ad$-DES',
  legalperson: "w@y2n3m$Ad$-LGL",
  content_writer:"w@y2n3m$Ad$-CNW",
  vendor_admin: "w@y2n3m$Ad$-VND"
};

export const stateOptions = [
  {
    state_id: 1,
    state_name: "Andhra Pradesh",
    lang_id: 1,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 2,
    state_name: "Arunachal Pradesh",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 3,
    state_name: "Assam",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 4,
    state_name: "Bihar",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "बिहार",
    towns: "पटना, गया, भागलपुर",
  },
  {
    state_id: 5,
    state_name: "Chhattisgarh",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "छत्तीसगढ़",
    towns: "रायपुर, बिलासपुर, भिलाई",
  },
  {
    state_id: 6,
    state_name: "Goa",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 7,
    state_name: "Gujarat",
    lang_id: 8,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 8,
    state_name: "Haryana",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "हरियाणा",
    towns: "चंडीगढ़, गुरुग्राम, फरीदाबाद",
  },
  {
    state_id: 9,
    state_name: "Himachal Pradesh",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "हिमाचल प्रदेश",
    towns: "शिमला, हमीरपुर, कुल्लू",
  },
  {
    state_id: 10,
    state_name: "Jammu and Kashmir",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "जम्मू और कश्मीर",
    towns: "श्रीनगर, जम्मू, राजौरी",
  },
  {
    state_id: 11,
    state_name: "Jharkhand",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "झारखंड",
    towns: "रांची, धनबाद, जमशेदपुर",
  },
  {
    state_id: 12,
    state_name: "Karnataka",
    lang_id: 4,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 13,
    state_name: "Kerala",
    lang_id: 5,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 14,
    state_name: "Madhya Pradesh",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "मध्य प्रदेश",
    towns: "भोपाल, इंदौर, ग्वालियर",
  },
  {
    state_id: 15,
    state_name: "Maharashtra",
    lang_id: 6,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 16,
    state_name: "Manipur",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 17,
    state_name: "Meghalaya",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 18,
    state_name: "Mizoram",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 19,
    state_name: "Nagaland",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 20,
    state_name: "Odisha",
    lang_id: 10,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  // {
  //   state_id: 25,
  //   state_name: "Odisha 25",
  //   lang_id: 10,
  //   status: "active",
  //   defaultid: 1,
  //   state_local: "NULL",
  //   towns: "NULL",
  // },
  {
    state_id: 21,
    state_name: "Punjab",
    lang_id: 9,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 22,
    state_name: "Rajasthan",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "राजस्थान",
    towns: "जयपुर, उदयपुर, अजमेर",
  },
  {
    state_id: 23,
    state_name: "Sikkim",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 24,
    state_name: "Tamil Nadu",
    lang_id: 2,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 25,
    state_name: "Telangana",
    lang_id: 1,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 26,
    state_name: "Tripura",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 27,
    state_name: "Uttar Pradesh",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "उत्तर प्रदेश",
    towns: "लखनऊ, कानपुर, इलाहाबाद",
  },
  {
    state_id: 28,
    state_name: "Uttarakhand",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "उत्तराखंड",
    towns: "देहरादून, हरिद्वार, पौड़ी",
  },
  {
    state_id: 29,
    state_name: "West Bengal",
    lang_id: 7,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 30,
    state_name: "Delhi",
    lang_id: 3,
    status: "active",
    defaultid: 1,
    state_local: "दिल्ली",
    towns: "मध्य दिल्ली, उत्तर दिल्ली, दक्षिण दिल्ली",
  },
  {
    state_id: 31,
    state_name: "Chandigarh",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 32,
    state_name: "Andaman and Nicobar Islands",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 33,
    state_name: "Dadra and Nagar Haveli",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 34,
    state_name: "Daman and diu",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 35,
    state_name: "Lakshadweep",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 36,
    state_name: "Puducherry",
    lang_id: 11,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
  {
    state_id: 37,
    state_name: "HCR",
    lang_id: 1,
    status: "active",
    defaultid: 1,
    state_local: "NULL",
    towns: "NULL",
  },
];

export const positionalRageOptions = [
  {
    label: "SOV",
    value: "sov",
  },
  {
    label: "0",
    value: "0",
  },
  {
    value: "1",
    label: "1",
  },
  {
    label: "3",
    value: "3",
  },
  {
    label: "5",
    value: "5",
  },
  {
    label: "9",
    value: "9",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "27",
    value: "27",
  },
];

export const mandalPositionalRageOptions = [
  {
    label: "SOV",
    value: "sov",
  },
  {
    label: "0",
    value: "0",
  },
  {
    label: "2-3",
    value: "2-3",
  },
  {
    label: "4-5",
    value: "4-5",
  },
  {
    label: "6-9",
    value: "6-9",
  },
  {
    label: "11-12",
    value: "11-12",
  },
  {
    //   label: "16-19",
    //   value: "16-19"
    // }, {
    label: "21-35",
    value: "21-35",
  },
  {
    label: "41-50",
    value: "41-50",
  },
];

export const advertiserTypes = [
  {
    value: "local",
    label: "Local",
  },
  {
    value: "metros",
    label: "Metros",
  },
];

export const minimumSpendOptions = [
  { value: "1000-2000", label: "1000-2000" },
  { value: "10000-20000", label: "10000-20000" },
  { value: "5000-60000", label: "5000-60000" },
];

export const langoptions = [
  { value: 1, label: "Telugu" },
  { value: 2, label: "Tamil" },
  { value: 3, label: "Hindi" },
  { value: 4, label: "Kannada" },
  { value: 5, label: "Malayalam" },
  { value: 6, label: "Marathi" },
  { value: 7, label: "Bengali" },
  { value: 8, label: "Gujarati" },
  { value: 9, label: "Punjabi" },
  { value: 10, label: "Odia" },
  { value: 11, label: "English" },
  { value: 13, label: "Telugu-English" }
];

export const langNames = ["", "Telugu", "Tamil", "Hindi", "Kannada", "Malayalam", "Marathi", "Bengali", "Gujarati", "Punjabi", "Odia", "English", "", "Telugu-English"]

export const osNames = ["All", "Android", "IOS"]
export const appCategoryNames = ["All", "News", "Business", "Sports", "Cinema", "Special", "Politics"]
export const genderNames = ["All", "Male", "Female"]
export const paymentNames = ["Unpaid", "Paid", "Wayoff"]



export const osOptions = [
  { label: "ALL", value: "0" },
  { label: "Android", value: "1" },
  { label: "IOS", value: "2" },
];

export const genderOptions = [
  { label: "ALL", value: 0 },
  { label: "Male", value: 1 },
  { label: "Female", value: 2 },
];

export const appCategoryOptions = [
  { value: "0", label: "All", isDisabled: false },
  { value: "3", label: "Sports", isDisabled: false },
  { value: "1", label: "News", isDisabled: false },
  { value: "2", label: "Business", isDisabled: false },
  { value: "4", label: "Cinema", isDisabled: false },
  { value: "5", label: "Special", isDisabled: false },
  { value: "6", label: "Politics", isDisabled: false },
];
export const commentAdCategories = [
  { value: '10013', label: 'భక్తి', isdisabled: true },
  { value: '10008', label: 'జ్యోతిష్యం', isdisabled: true },
  { value: '10009', label: 'పంచాంగం', isdisabled: true },
  { value: '10012', label: 'ఉద్యోగాలు', isdisabled: true },
  { value: '10015', label: 'పాడి పంట', isdisabled: true },
  { value: '10014', label: 'వసుధ', isdisabled: true }
]
export const creativeTypeOps = [
  {
    value: "image",
    label: "Image",
  },
  {
    value: "video",
    label: "Video",
  },
  {
    value: "promotedStory",
    label: "Promoted Story",
  },
  {
    value: "animation",
    label: "Animation",
  },
  {
    value: "webviewad",
    label: "Web View Ad",
  },
  {
    value: "commentad",
    label: "Comment Ad",
  },
  {
    value: "brandAd",
    label: "Brand Ad",
  },
  {
    value: "brandad",
    label: "Brand Ad",
  },
  {
    value:"classifieds",
    label:"Classifieds"
  },
  {
    value:"framepost",
    label:"Frame Post"
  },
  {
    value:"recad",
    label:"Recommended Ads"
  },
  {
    value:"widget",
    label:"Widget"
  }
];

export const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_image",
    label: "Full Image",
  },
  {
    value: "gallery",
    label: "Gallery",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
    value: "half_video",
    label: "Half Video",
  },
  // {
  //   value: "video_with_bg",
  //   label: "Video with Bg",
  // },
  {
    value: "fullvideo_or_gif",
    label: "Fullvideo or Gif",
  },
  {
    value: "promoted_video_story",
    label: "Promoted Video Story ",
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story",
  },
  {
    value: "promoted_gallery",
    label: "Promoted Gallery",
  },
  {
    value: "webviewad",
    label: "WebView Ad",
  },
  {
    value: "commentad",
    label: "Comment Ad",
  },
  {
    value: "brandAd",
    label: "Brand Ad",
  },
  // { value: "search", label: "Search" },
  // { value: "unread", label: "Unread" },
  { value: "news_image_flip", label: "News-Image Flip" },
  { value: "news_image_logo", label: "News-Image Logo" },
  // { value: "news_short_desc", label: "News-Short Description" },
  { value: "video_expandable", label: "Video Expandable" },
  { value: "video_endcard", label: "Video Endcard" },
  { value: 'bottom_rectangle', label: 'Bottom Rectangle' },
  // { value: "video_skippable", label: "Video Skippable" },
  {value:"square_classified",label:'Square Classified'},
  {value:"rectangle_classified", label:"Rectangle Classified"},
  {value:"framepost", label:"Frame Post"},
  {value:"rec_image", label:"Recommend Image"},
  {value:'rec_promoted_story', label:"Recommend Promoted Story"},
  {value:"job_listings", label:"Job Listings"},
  {value:"business_listings", label:"Business Listings"},
  {value:"specials", label:"Specials"}
];
export const  iconMap = {
  "full_image": { icon: "image", label: "Full Image" },
  "gallery": { icon: "images", label: "Gallery" },
  "full_video": { icon: "play-circle", label: "Full Video" },
  "half_video": { icon: "play-circle", label: "Half Video" },
  "fullvideo_or_gif": { icon: "filetype-gif", label: "Fullvideo or Gif" },
  "promoted_image_story": { icon: "image", label: "Promoted Image Story" },
  "promoted_gallery": { icon: "images", label: "Promoted Gallery" },
  "webviewad": { icon: "globe", label: "WebView Ad" },
  "commentad": { icon: "message-circle", library: "lucide", label: "Comment Ad" },
  "search": { icon: "search", library: "lucide", label: "Search" },
  "unread": { icon: "eye-off", library: "lucide", label: "Unread" },
  "news_image_flip": { icon: "box", library: "lucide", label: "News-Image Flip" },
  "news_image_logo": { icon: "layout-list", library: "lucide", label: "News-Image Logo" },
  "news_short_desc": { icon: "layout-list", library: "lucide", label: "News-Short Description" },
  "video_expandable": { icon: "video", library: "lucide", label: "Video Expandable" },
  "video_endcard": { icon: "video", library: "lucide", label: "Video Endcard" },
  "video_skippable": { icon: "skip-forward", library: "lucide", label: "Video Skippable" },
  "bottom_rectangle": { icon: "box", library: "lucide", label: "Bottom Rectangle" },
  "brandAd": { icon: "star", library: "lucide", label: "Brand Ad" },
  "rectangle_classified": { icon: "star", library: "lucide", label: "Rectangle Classified" },
  "square_classified": { icon: "star", library: "lucide", label: "Square Classified" },
  "framepost": { icon: "layout-list", library: "lucide", label: "Frame Post" },
  "rec_image": { icon: "star", library: "lucide", label: "Recommend Image" },
  "rec_promoted_story": { icon: "star", library: "lucide", label: "Recommend Promoted Story" },
  "promoted_video_story": { icon: "play-circle", label: "Promoted Video Story" },
  "default":{icon: "play-circle", label: "Default"},
  "job_listings":{ icon: "star", library: "lucide", label: "Job Listings" },
  "business_listings":{ icon: "star", library: "lucide", label: "Business Listings" },
  "specials":{ icon: "star", library: "lucide", label: "Specials" }
};
export const creativeTypeOpsMap = new Map(creativeTypeOps.map(item => [item.value, item.label]));
export const typesMap = new Map(types.map(item => [item.value, item.label]));

export const campaignStatus = [
  {
    label: "Created",
    value: 1,
  },
  {
    label: "Running",
    value: 2,
  },
  {
    label: "Paused",
    value: 3,
  },
  {
    label: "Completed",
    value: 4,
  },
  {
    label: "Scheduled",
    value: 5,
  },
  {
    label: "Approved",
    value: 6,
  }
];

export const reportStatus = [
  ,
  {
    label: "Running",
    value: 2,
  },
  {
    label: "Paused",
    value: 3,
  },
  {
    label: "Completed",
    value: 4,
  },
];

export const teams = [
  { label: "inbound", value: "inbound" },
  { label: "localsales", value: "localsales" },
  { label: "outbound", value: "outbound" },
  { label: "district revenue", value: "district revenue" },
  { label: "Metro", value: "metro" },
  { label: "govt", value: "govt" },
  { label: "panel", value: "panel" },
  { label: "video revenue", value: "video revenue" },
  { label: "magazine", value: "magazine" },
  { label: "Alpha", value: "alpha" },
  { label: "TamilNadu-LocalSales", value: "tamilnadu-localsales" },
  { label: "sponsored", value: "sponsored" },
  { label: "National-Banglore", value: "banglore" },
  { label: "National-Delhi", value: "delhi" },
  { label: "National-Mumbai", value: "mumbai" },
  { label: "National-Chennai", value: "chennai" },
  { label: "National-Existing", value: "existing" },
  { label: "National-kolkatta", value: "kolkatta"},
  { label: "Testing", value: "testing" },
  { label: "TamilNadu-MetroSales", value: "tamilnadu-metrosales" },
  { label: "Network", value: "network"},
  { label: "Job Listings", value: "joblistings" }
];

export const adTypes = [
  { value: "National", label: "National" },
  { value: "Local", label: "Local" },
  { value: "District", label: "District" },
];

export const newspaperLangs = [
  { value: 1, label: "Telugu" },
  { value: 2, label: "Tamil" },
  { value: 3, label: "Hindi" },
  { value: 4, label: "Kannada" },
  { value: 5, label: "Malayalam" },
  { value: 6, label: "Marathi" },
  { value: 7, label: "Bengali" },
  { value: 8, label: "Gujarathi" },
  { value: 9, label: "Punjabi" },
  { value: 10, label: "Oria" },
  { value: 11, label: "English" },
  { value: 13, label: "Telugu-English" }
];

export const orderTablePermissions = [
  { value: "impressions", label: "Impressions" },
  { value: "clicks", label: "Clicks" },
  { value: "ecpm", label: "ECPM" },
  { value: "spent", label: "Spent" },
  { value: "start_date", label: "Start Date" },
  { value: "end_date", label: "End Date" },
  { value: "ctr", label: "CTR" },
  { value: "order_value", label: "Order Value" },
  { value: 'ro_no', label:"Ro"}
];

export const InteractionStatus = {
  1: "In 1 week",
  2: "In 2 weeks",
  3: "In 3 weeks",
  4: "Later Next Month",
  5: "After 2 Months",
  6: "Campaign Recieved",
  7: "Not Interested",
  8: "No Visibility Yet",
};

export const InteractionType = {
  1: "Direct Meeting",
  2: "Virtual Meeting",
  3: "Call",
  4: "Whatsapp",
  5: "Email",
};
export const InteractionTypeProps = [
  {
    type: 1,
    name: "Direct Meeting",
    background_color: "#0080FF",
    text_color: "#FFFFFF",
  },
  {
    type: 2,
    name: "Virtual Meeting",
    background_color: "#FFB327",
    text_color: "#000000",
  },
  { type: 3, name: "Call", background_color: "#8b5cf6", text_color: "#000000" },
  {
    type: 4,
    name: "Whatsapp",
    background_color: "#3CAF41",
    text_color: "#FFFFFF",
  },
  {
    type: 5,
    name: "Email",
    background_color: "#f43f5e",
    text_color: "#000000",
  },
];

export const NewspaperMainEditonAdformats = [
  { value: "Full_Page_Ad", label: "Full Page Ad" },
  { value: "Half_Page_Ad", label: "Half Page Ad" },
  { value: "Quarter_Page_Ad", label: "Quarter Page Ad" },
  { value: "Small_Ad", label: "Small Ad" },
  { value: "skybus", label: "skybus" },
  { value: "Jacket_1", label: "Jacket - 1" },
  { value: "Jacket_2", label: "Jacket - 2" },
  { value: "Jacket_3", label: "Jacket - 3" },
  { value: "Jacket_4", label: "Jacket - 4" },
  { value: "Jacket_5", label: "Jacket - 5" },
  { value: "Jacket_6", label: "Jacket - 6" },
  { value: "Jacket_1_C", label: "Jacket - 1 C" },
  { value: "Jacket_2_C", label: "Jacket - 2 C" },
  { value: "Jacket_3_C", label: "Jacket - 3 C" },
  { value: "Jacket_4_C", label: "Jacket - 4 C" },
  { value: "Jacket_5_C", label: "Jacket - 5 C" },
  { value: "Jacket_6_C", label: "Jacket - 6 C" },
];

export const NewspaperDistrictEditonAdformats = [
  { value: "Full_Page_Ad", label: "Full Page Ad" },
  { value: "Half_Page_Ad", label: "Half Page Ad" },
  { value: "Quarter_Page_Ad", label: "Quarter Page Ad" },
  { value: "Small_Ad", label: "Small Ad" },
  { value: "skybus", label: "skybus" },
];

export const NewspaperOptions = async () => {
  let Newspapers = [];
  try {
    let res = await API({
      url: "/market/newspapers",
      method: "POST",
      responseType: "json",
      data: {},
    });
    if (res.code === 200) {
      Newspapers = res.data
        .filter((item) => item.name.toLowerCase() !== "way2news") // Filter out 'way2news'
        .map((item) => {
          return {
            value: item.name,
            label: item.name,
          };
        });
    }
  } catch (error) {
    console.error(error);
  }
  return Newspapers;
};

export const BirdviewStates = [
  { value: "AP", label: "AP" },
  { value: "TS", label: "Telangana" },
  { value: "TN", label: "Tamilnadu" },
];

export const getGenerateUrl = (brandName) => {
  brandName = brandName.toLowerCase().split(" ").join("_");
  let URL = config.AWS_BRAND_URL + brandName + ".jpg";
  return URL;
};
export const brandLabels = [
  { label: "Strategic Client", value: 1 },
  { label: "SMB’s & Others", value: 2 },
  { label: "Enterprise clients", value: 3 },
];

export const OddMonths = [
  "February",
  "April",
  "June",
  "August",
  "October",
  "December",
];

export const defaultValue = (options, value) => {
  return options ? options.find((option) => option.value === value) : "";
};

export const slotBooking_campaign_types = [
  { label: "CPD", value: "CPD" },
  { label: "CPM", value: "CPM" },
  // { label: "CPC", value: "CPC" },
];

export const orderBookingCampaignTypes = [
  {label:"CPD", value:"CPD"},
  { label: "CPM", value: "CPM" },
  { label: "CPC", value: "CPC" },
  { label: "Magazines", value: "Magazines"},
  { label: "Stories", value: "Stories"}
]

export const slotBookingCreativeTypes = [
  { value: "Full Page",label: "Full Page"},
  { value: "Full Page Video",label: "Full Page Video"},
  { value: "Promoted Story",label: "Promoted Story"},
  // Magazines
  { label: "Magazines", value: "brandAd" },
  // recommend ads
  { value: 'rec_promoted_story', label:"Recommend Promoted Story"},
  { value: "rec_image", label:"Recommend Image"},
  // classified ads
  { label: "Rectangle Classified", value : "rectangle_classified"},
  // brandAd
  { value: "news_image_flip", label: "News-Image Flip" },
  { value: "news_image_logo", label: "News-Image Logo" },
  { value: "video_expandable", label: "Video Expandable" },
  { value: "video_endcard", label: "Video Endcard" },
  { value: 'bottom_rectangle', label: "Bottom Rectangle" },
  //jobs
  {value:"job_listings", label:"Job Listings"},
  {value:"business_listings", label:"Business Listings"}
];

export const billingOptions = [
  { label: "Billing", value: 1 },
  { label: "Non Billing", value: 0 },
];

export const slotPositions = [-1, 0, 1, 3, 5, 9, 12, 13, 15, 17, 19, 23, 27, 31, 35, 39, 43, 47, 51, 55, 59, 63, 67, 71, 75, 79, 83, 87, 91, 95, 99];

export const adPositions = [ -1, 0, 1, 4, 9, 12, 15, 17, 19, 23, 27, 31, 35, 39, 43, 47, 51, 55, 59, 63, 67, 71, 75, 79, 83, 87, 91, 95, 99 ];

export const slotStatusOptions = [
  { label: "Select By Status", value: 0 },
  { label: "Pending", value: 1 },
  { label: "Finance Pending", value: 2 },
  { label: "Approved", value: 3 },
  { label: "Rejected", value: 4 },
  { label: "Cancelled", value: 5 },
];
export const slotPaymentTypeOptions = [
  { label: "Prepaid", value: 1 },
  { label: "PostPaid(RO)", value: 2 },
  { label: "PDC", value: 3 },
  { label: "Partial Credit", value: 4 },
];
export const dealTypeOptions = [
  { label: "Direct Deal", value: 1 },
  { label: "PG Deal", value: 2 },
];
export const slotPaymentMethodOptions = [
  { label: "QR Code", value: 1 },
  { label: "IFSC", value: 2 },
  { label: "Payment Link", value: 3 },
  { label: "RO", value: 4 },
];
export const slotPackagesOptions = [
  { label: "Single Ad", value: 1 },
  { label: "3 + 1", value: 2 },
  { label: "4 + 1", value: 3 },
  { label: "5 + 2", value: 4 },
  { label: "20 + 10", value: 5 },
];
export const slotOptions = ["A", "B", "C", "D"];
export const bannerOptions = [
  { label: "300x250", value: "300x250" },
  { label: "300x600", value: "300x600" },
  { label: "320x480", value: "320x480" },
  { label: "Native", value: "native" },
];
export const rejectMessOptions = [
  "",
  "RO is not clear",
  "RO & Value Mis-matched",
  "Transaction Not Found",
  "Date Mis-matched",
  "Position Not Matched",
];
export const financeUserTypes = [
  { label: "Associate", value: 0 },
  { label: "Manager", value: 1 },
  { label: "Director", value: 2 },
];

export const BrandsTypes = [
  { value: 1, label: "National" },
  { value: 2, label: "Local-Telugu" },
  { value: 3, label: "Metro-Telugu" },
  { value: 4, label: "Tamil-Metro" },
  { value: 5, label: "Alpha" },
  { value: 7, label: "Local-Govt"},
  { value: 8, label: "Tamil-Local"},
  { value: 9, label: "Inbound1"},
  { value: 10, label: "Alpha-Govt"},
  { value: 11, label: "Inbound-Jobs"},
  { value: 12, label: "Inbound2"},
  { value: 13, label: "Inbound-Classifieds"}
];
export const getBrandOptions = (usertype, email) => {
  if (usertype === -1) {
    return BrandsTypes; // Return all options if usertype is -1
  }

  if (email === "raghu@way2news.com" || email === "raghu@way2news.co") {
    return BrandsTypes.filter((option) => option.value === 2 || option.value === 5);
  }

  return BrandsTypes.filter((option) => option.value === usertype);
};
export const localTypes = [2, 3, 4, 5, 9];

export function toLakhs(amount) {
  if (!isFinite(amount) || amount === 0) {
    return 0;
  }

  let absAmount = Math.abs(amount);
  let formattedAmount;
  let unit;
  if(absAmount < 1000){
    return parseInt(absAmount)
  }
  else if (absAmount <= 10000) {
    formattedAmount = (absAmount / 1000).toFixed(2);
    unit = "k";
  } else if (absAmount >= 10000000) {
    // 1 crore = 10,000,000
    formattedAmount = (absAmount / 10000000).toFixed(2);
    unit = "Cr";
  } else {
    // 1 lakh = 100,000
    formattedAmount = (absAmount / 100000).toFixed(2);
    unit = "L";
  }

  // Preserve the sign
  return ((amount < 0 ? "-" : "") + formattedAmount + " " + unit);
}

export const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("reduxState");
    if (serializedState === null) return undefined; // Undefined to load the initial state
    return JSON.parse(serializedState);
  } catch (error) {
    console.error("Error loading state from localStorage:", error);
    return undefined;
  }
};

export const saveStateToLocalStorage = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("reduxState", serializedState);
  } catch (error) {
    console.error("Error saving state to localStorage:", error);
  }
};
export const handleClickhdl = async (text) => {
  if (text) {
    await navigator.clipboard.writeText(text);
    Toast("success", "Copied");
  }
};

export const handleDate = (item) => {
  let list = []
  item?.map((d1, index) => {
      return (
          <p key={index}>
              {list = [...list, { sdate: '', edate: '' }]}
              {list[index]['sdate'] = formatDateWithTime(d1.sdate)}
              {list[index]['edate'] = formatDateWithTime(d1.edate)}
          </p>
      )
  })
  return [...list]

}

export const getNumberOfDays = (date_ranges) => {
  let daysCount = 0;
  date_ranges.map((range) => {
    let start_date = new Date(range.start_date * 1000),
      end_date = new Date(range.end_date * 1000);
    daysCount += differenceInDays(end_date, start_date) + 1;
  });
  return daysCount;
};

export const getNumberOfDaysForNormalDays = (date_ranges) => {
  let daysCount = 0;
  date_ranges.map((range) => {
    let start_date = new Date(range.startDate),
      end_date = new Date(range.endDate);
    daysCount += differenceInDays(end_date, start_date) + 1;
  });
  return daysCount;
};

export const copyText = async (text,message = 'Copied') => {
  if (text) {
    await navigator.clipboard.writeText(text);
    Toast("success", message);
  }
};

export const magazineCreatives = [
  // 'unread',
  'news_image_flip', 'news_image_logo',
  //   'news_short_desc',
  'video_expandable',
  'video_endcard',
  //  'video_skippable',
  'bottom_rectangle'
]

export const magazineCreativeOptions = [
  //   { value: "unread", label: "Unread" },
  { value: "news_image_flip", label: "News-Image Flip" },
  { value: "news_image_logo", label: "News-Image Logo" },
  //   { value: "news_short_desc", label: "News-Short Description" },
  { value: "video_expandable", label: "Video Expandable" },
  { value: "video_endcard", label: "Video Endcard" },
  //   { value: "video_skippable", label: "Video Skippable" }
  { value: 'bottom_rectangle', label: "Bottom Rectangle" },
  //   { value: "video_skippable", label: "Video Skippable" }
]

export const classifiedCreativeOptions = [
  {value:"square_classified",label:'Square Classified'},
  {value:"rectangle_classified", label:"Rectangle Classified"}
]
export const classifiedCreatives = ["square_classified", "rectangle_classified"]

export const recadCreatives = ['rec_image', 'rec_promoted_story']

export const widgetCreatives = ["job_listings", "business_listings", "specials"]


export const recadCreativeOptions = [
  {value: "rec_image", label: "Recommended Image"},
  {value: "rec_promoted_story", label: "Recommended Promoted Story"},
]

export const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export const hardInteractionTypes = [1,2]

export const softInteractionTypes = [3,4,5]

export const w2n_android_versions = [{label: "Select", value: ""},{label: "8.86", value: "8.86"}, {label: "8.89", value: "8.89"}, 
  {label: "8.90", value: "8.90"}, {label: "8.94", value: "8.94"}, {label: "8.97", value: "8.97"}, {label: "8.99", value: "8.99"}, {label: "9.0", value: "9.0"}, {label: "9.1", value: "9.1"}, {label: "9.21", value: "9.21"}, {label: "9.22", value: "9.22"}, {label: "9.23", value: "9.23"}, { label: "9.24", value: "9.24"}, {label: "9.26", value: "9.26"}, {label: "9.46", value: "9.46"}, {label: "9.48", value: "9.48"}]

export const w2n_ios_versions = [{label: "Select", value: ""},{label: "8.0", value: "8.0"}, {label: "8.2", value: "8.2"}, {label: "8.3", value: "8.3"}, {label: "8.4", value: "8.4"}, {label: "8.5", value: "8.5"}, {label: "8.6", value: "8.6"}, {label :"8.7", value: "8.7"}, {label :"9.2", value: "9.2"}]



export const clusters = {
  'Anantapur':['Rayadurgam','Guntakallu','Anantapur'],
  'Sri Sathya Sai':['Hindupur','Puttaparthi'],
  'Guntur':['Tenali','Managalagiri','Guntur East','Guntur West'],
  'Palnadu':['Narasaraopet','Sattenapalli'],
  'Nandyal  ':['Allagadda','Nandyala'],
  'Y.S.R. (Cuddapah)':['Prodduturu','Kadapa'],
  'Krishna':['Machalipatnam','Penamaluru','Gudiwada'],
  'NTR':['Tiruvuru','Nandigama','Vijayawada East','Vijayawada West','Vijayawada Central'],
  'Kurnool':['Adoni','Yemmiganuru','Kurnool'],
  'Prakasam':['Markapuram','Kanigiri','Ongole'],
  'Bapatla':['Bapatla','Chirala'],
  'Ambedkar konaseema':['Rajolu','Amalapuram','Mandapet'],
  'East Godavari':['Rajamahendravaram','Rajamahendravaram Rural','Kovvuru'],
  'Kakinada':['Kakinada Rural','Tuni'],
  'Nellore':['Kavali','Kovuru'],
  'Srikakulam':['Palasa','Tekkili','Srikakulam'],
  'Eluru':['Polavaram','Nuziveedu'],
  'West Godavari':['Bhimavaram','Narasapuram','Tadepalligudem'],
  'Annamayya':['Madanapalle','Rayachoti'],
  'Chittoor':['Palamaneru','Chittoor'],
  'Tirupati':['Guduru','Srikalahasthi'],
  'Anakapalli':['Narsipatnam','Pendurthi'],
  'Visakhapatnam':['Pendurthi','Bheemili','Visakha East','Visakha North','Gajuwaka'],
  'Vizianagaram':['Bobbili','Vizianagaram'],
  "LB NAGAR": ["LB NAGAR", "MALAKPET"],
  "MAHESWARAM": ["MAHESWARAM", "IBRAHTMPATNAM", "KALAWAKURTHY"],
  "CHARMINAR": ["CHARMTNAR", "GOSHAMAHAL", "NAMPALLY", "KARWAN", "CHANDRAYAN GUTTA", "BAHADURPURA", "YAKAUTPURA"],
  "RAJENDRANAGAR": ["RAJENDRANAGAR", "SHADNAGAR", "CHEVELLA"],
  "SECUNDERABAD": ["SECUNDERABAD", "CANTONMEMT", "SANATH NAGAR"],
  "MUSHEERABAD": ["MUSHEERABAD", "AMBERPET"],
  "MALKAJGIRI": ["MALKAJGIRI"],
  "UPPAL": ["UPPAL", "MEDCHAL"],
  "KHAIRATABAD": ["KHAIRATABAD", "JUBILEE HILLS"],
  "KUKATPALLY": ["KUKATPALLY"],
  "SERILINGAMPALLY": ["SERILINGAMPALLY", "PATANCHERU"],
  "QUTHBULLAPUR": ["QUTHBULLAPUR"],
  "SURYAPET": ["SURYAPET", "TUNGATURTHI"],
  "KODADA": ["KODADA", "HUZURNAGAR"],
  "NALGONDA": ["NALGONDA", "MUNAGODU", "NAKIREKAL"],
  "MIRYALAGUDA": ["MIRYALAGUDA", "DEVARAKONDA", "NAGARJUNA SAGAR"],
  "KHAMMAM": ["KHAMMAM", "PALERU"],
  "SATTUPALLI": ["SATTUPALLI", "MADHIRA", "WYRA"],
  "KOTHAGUDEM": ["KOTHAGUDEM", "ILLENDU"],
  "BHADRACHALAM": ["BHADRACHALAM", "PINAPAKA", "ASWARAOPETA"]

}

export const pricePackages = [
  // {label: "1 Week", value: 1},
  // {label: "2 Week", value: 2},
  {label: "3 Week", value: 3},
  {label: "6 Week", value: 6},
  {label: "9 Week", value: 9},
  // {label: "12 Week", value: 12}
]

export const LocalPricePackages = [
  {label: "4 Week", value: 4},
  {label: "8 Week", value: 8},
  {label: "12 Week", value: 12},
]

export const packageNewOldOptions = [
  {label: 'Old', value: "old"},
  {label: 'New', value: "new"},
]

export const classifiedSectionCategories = [
  { label: "Personal - Birthday, Birthday Wishes, Sastipurthi", value: "per_birthday_birthday_wishes_sastipurthi" },
  { label: "Commercial - Textile, Retail, Jewellery", value: "com_textile_retail_jewellery" },
  { label: "Commercial - Health", value: "com_health" },
  { label: "Commercial - Education", value: "com_education" },
  { label: "Commercial - Real Estate", value: "com_real_estate" },
  { label: "Commercial - Automobile", value: "com_automobile" },
  { label: "Commercial - Hotels, Restaurants, FMCG", value: "com_hotels_restaurants_fmcg" },
  { label: "Commercial - Tours & Travels", value: "com_tours_travels" },
  { label: "Commercial - Agriculture", value: "com_agriculture" },
  { label: "Commercial - Events & Exhibitions", value: "com_events_exhibitions" },
  { label: "Personal - Political Greetings", value: "per_political_greetings" },
  { label: "Personal - Retirements", value: "per_retirements" },
  { label: "Personal - OBT", value: "per_obt" },
  { label: "Personal - Campus Selection", value: "per_campus_selection" },
  { label: "Personal - Rankers Greetings", value: "per_rankers_greetings" },
  { label: "Personal - Winners in Sports", value: "per_winners_in_sports" },
  { label: "Personal - Professionals Awards", value: "per_professionals_awards" },
  { label: "Personal - Marriage Ads", value: "per_marriage_ads" },
  { label: "Personal - Gruhapravesam", value: "per_gruhapravesam" },
  { label: "Personal - Transfers & Promotions", value: "per_transfers_promotions" },
  { label: "Commercial - Bank & Commercial Anniversaries", value: "com_bank_commercial_anniversaries" },
  { label: "Personal - Spiritual Ads", value: "per_spiritual_ads" },
  { label: "Personal - Sanghalu-Karyavargalu (Non-Political)", value: "per_sanghalu_karyavargalu" },
  { label: "Personal - Others", value: "per_others" },
  { label: "Commercial - Others", value: "com_others" }
];

export const makerCheckerActions = [
  { label: "Brand Creation", value: 1 },
  { label: "Brand Updation", value: 2 }
];



export const DESIGN_OPTIONS = [
  { label: "Design (old)", value: 1 },
  { label: "Button Center", value: 2 },
  { label: "Button Right", value: 3 },
  { label: "Button Full", value: 4 },
  {label:"Full Page", value:5}
];

export const FULLSCRTYPE_OPTIONS = [
  { label: "Image", value: 1 },
  { label: "Video", value: 2 },
]

export const relationOptions = [
  { value: 1, label: "Father" },
  { value: 2, label: "Mother" },
  { value: 3, label: "Son" },
  { value: 4, label: "Daughter" },
  { value: 5, label: "Others" },
  { value: 6, label: "Husband" },
  { value: 7, label: "Wife" },
];
export const EenaduAdsTypes = [
  {label:"State",value:"state"},
  {label:"Region",value:"region"},
  {label:"Editions",value:"edition"},
  {label:"Districts",value:"district"},
  {label:"Clusters",value:"cluster"}
]
export const EenaduAdSizes = [
  {label:"Fixed",value:"fixed"},
  {label:"SqCm",value:"sqcm"}
]

export const getMidnightTimestamp = (timestamp = Math.floor(Date.now()/1000), daysOffset = 0) => {
    const date = new Date(timestamp * 1000); 
    const resultDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + daysOffset
    );
    return Math.floor(resultDate.getTime() / 1000); 
}


export const customReportDimensions = [
  { value: "sales_person_id", label: "Sales Person Name" },
  { value: "campaign_name", label: "Line item Name" },
  { value: "order_name", label: "Order Name" },
  { value: "position", label: "Position" },
  { value: "lang_id", label: "Language" },
  { value: "date", label: "Date" },
  { value: "brand_name", label:"Brand Name"}
];
export const customReportMetrics = [
  { value: "impressions", label: "Impressions" },
  { value: "clicks", label: "Clicks" },
  { value: "spent", label: "Revenue" },
  { value: "adv_impressions", label: "Adv Impressions" },
  { value: "adv_clicks", label: "Adv Clicks" },
  { value: "adv_spent", label: "Adv Revenue" },
]
export const customReportHeaders = [
  { value: "sales_name", label: "Sales Person Name" },
  { value: "sales_person_id", label: "Sales Person ID" },
  { value: "campaign_name", label: "Line item Name" },
  { value: "campaign_id", label: "Line item ID" },
  { value: "order_name", label: "Order Name" },
  { value: "order_id", label: "Order ID" },
  {value: "brand_name", label: "Brand Name"},
  { value: "position", label: "Position" },
  { value: "lang_id", label: "Language" },
  { value: "date", label: "Date" },
  { value: "impressions", label: "Impressions" },
  { value: "clicks", label: "Clicks" },
  { value: "spent", label: "Revenue" },
  { value: "adv_impressions", label: "Adv Impressions" },
  { value: "adv_clicks", label: "Adv Clicks" },
  { value: "adv_spent", label: "Adv Revenue" },
]

export const brandTypeObj = {
              'National':1,
              'Metro-Telugu':3,
              'Tamil-Metro':4,
              'Alpha':5,
              'Local-Telugu':2,
              'Local-Govt':7,
              'Tamil-Local':8,
              'Inbound1':9, 
              'Alpha-Govt':10,
              'Inbound-Jobs':11,
              'Inbound2':12,
              'Inbound-Classifieds':13
              }
export const alphaTypes = [brandTypeObj["Alpha"], brandTypeObj['Inbound1'], brandTypeObj['Inbound-Classifieds'], brandTypeObj['Inbound-Jobs'], brandTypeObj['Inbound2']]

export const pxToCm = (px, dpi = 96) => {
  return Math.round(px/dpi)
}
export const fetchMatchAdCodeAlert = async(body) => {
  try {
    let result = await API({
      url: "/adunit/matchAdCodeAlert",
      method: "POST",
      data: body,
    })
    if(result.code === 200){
      return result.data || []
    }
    else{
      return []
    }
  } catch (error) {
    console.error("Error @ fetchMatchAdCodeAlert", error)
  }
}


export const oldCategoryOptions = [ // total count = 82
  // 64 non alpha categories
  { value: 18, label: "retail - non alpha" },
  { value: 19, label: "fmcg - non alpha" },
  { value: 20, label: "healthcare & hospitals - non alpha" },
  { value: 21, label: "education & careers - non alpha" },
  { value: 22, label: "bfsi - non alpha" },
  { value: 23, label: "real estate / construction - non alpha" },
  { value: 24, label: "automobile / travel / transport - non alpha" },
  { value: 25, label: "others - non alpha" },
  { value: 26, label: "services - non alpha" },
  { value: 27, label: "consumer durables / electronics / mobiles - non alpha" },
  { value: 28, label: "govt , psus - non alpha" },
  { value: 29, label: "personal - non alpha" },
  { value: 30, label: "consumer durables / electronics / mobiles - non alpha" },
  { value: 31, label: "automobile / travel / transport - non alpha" },
  { value: 32, label: "none - non alpha" },
  { value: 62, label: "personal - sanghalu-karyavargalu (non-political) - non alpha" },
  { value: 63, label: "personal - political greetings - non alpha" },
  { value: 64, label: "personal - obt - non alpha" },
  { value: 65, label: "personal - others - non alpha" },
  { value: 66, label: "personal - birthday wishes, sastipurthi - non alpha" },
  { value: 67, label: "personal - retirements - non alpha" },
  { value: 68, label: "commercial - education - non alpha" },
  { value: 69, label: "personal - sardhanjali - non alpha" },
  { value: 70, label: "personal - welcome wishes - non alpha" },
  { value: 71, label: "commercial - events & exhibitions - non alpha" },
  { value: 72, label: "commercial - commercial anniversaries - non alpha" },
  { value: 73, label: "personal - marriage ads - non alpha" },
  { value: 74, label: "personal - transfers & promotions - non alpha" },
  { value: 75, label: "commercial - bank & commercial anniversaries - non alpha" },
  { value: 76, label: "personal - professionals awards - non alpha" },
  { value: 77, label: "commercial - others - non alpha" },
  { value: 78, label: "commercial - health - non alpha" },
  { value: 79, label: "personal - spiritual ads - non alpha" },
  { value: 80, label: "personal - gruhapravesam - non alpha" },
  { value: 81, label: "commercial - textile, retail, jewellery - non alpha" },
  { value: 82, label: "commercial - real estate - non alpha" },
  { value: 83, label: "commercial - hotels, restaurants, fmcg - non alpha" },
  { value: 84, label: "commercial - automobile - non alpha" },
  { value: 85, label: "personal - campus selection - non alpha" },
  { value: 98, label: "realestate and construction - non alpha" },
  { value: 99, label: "commercial-appointment - non alpha" },
  { value: 100, label: "tenders - govt - non alpha" },
  { value: 101, label: "public notice - non alpha" },
  { value: 102, label: "tenders - institutional - non alpha" },
  { value: 103, label: "legal notice - non alpha" },
  { value: 104, label: "land aqusitions - non alpha" },
  { value: 105, label: "commercial - agriculture - non alpha" },
  { value: 123, label: "private notices/tenders - non alpha" },
  { value: 124, label: "bfsi/private banks - non alpha" },
  { value: 125, label: "bfsi/finance/private banks - non alpha" },
  { value: 126, label: "other commercials - non alpha" },
  { value: 127, label: "appointment - non alpha" },
  { value: 128, label: "govt-state/central - non alpha" },
  { value: 129, label: "education - non alpha" },
  { value: 130, label: "events and exhibition - non alpha" },
  { value: 131, label: "health care - non alpha" },
  { value: 132, label: "real estate - non alpha" },
  { value: 134, label: "commercial - non alpha" },
  { value: 135, label: "textiles/apparels - non alpha" },
  { value: 136, label: "districts - non alpha" },
  { value: 137, label: "life style - non alpha" },
  { value: 138, label: "tours and travels - non alpha" },
  { value: 139, label: "main - non alpha" },
  { value: 140, label: "govt. state/ central - non alpha" },

  // oldCategoryOptions (18 items)
  { value: 106, label: "Education" },
  { value: 107, label: "Private Notices/Tenders" },
  { value: 109, label: "Life Style" },
  { value: 110, label: "Retail" },
  { value: 112, label: "Appointment" },
  { value: 113, label: "Other Commercials" },
  { value: 114, label: "Health care" },
  { value: 115, label: "Textiles/Apparels" },
  { value: 116, label: "Classifieds" },
  { value: 117, label: "BFSI/Finance/Private Banks" },
  { value: 118, label: "Tours and Travels" },
  { value: 119, label: "Real Estate" },
  { value: 120, label: "Events and Exhibition" },
  { value: 121, label: "Agricultural" },
  { value: 122, label: "BFSI/PRIVATE BANKS" },
];


export const oldSubCategoryOptions = [
  { value: 1, label: "Jr/Deg/B.Ed/D.Ed Colleges", category_id: 106 },
  { value: 2, label: "Legal Notices", category_id: 107 },
  { value: 3, label: "General Notice", category_id: 107 },
  { value: 4, label: "Obituary", category_id: 108 },
  { value: 5, label: "Eng/PG/Mngt/Pharma/Medical/Nursing/Inds.Training", category_id: 106 },
  { value: 6, label: "Bon Voyage/Welcome", category_id: 108 },
  { value: 7, label: "Footwear", category_id: 109 },
  { value: 8, label: "Shopping Malls", category_id: 110 },
  { value: 9, label: "Birthdays", category_id: 108 },
  { value: 10, label: "Spiritual", category_id: 108 },
  { value: 11, label: "MISSING (PERSON/DOCUMENTS)", category_id: 108 },
  { value: 12, label: "Congratulations Message", category_id: 108 },
  { value: 13, label: "Notices State Govt", category_id: 111 },
  { value: 14, label: "ANNIVERSARIES", category_id: 108 },
  { value: 15, label: "Others", category_id: 108 },
  { value: 16, label: "Walk in Interviews", category_id: 112 },
  { value: 17, label: "Festival Greetings", category_id: 113 },
  { value: 18, label: "Textiles", category_id: 115 },
  { value: 19, label: "Education Services", category_id: 106 },
  { value: 20, label: "Coaching Centre/Academy", category_id: 106 },
  { value: 21, label: "Acknowledgements", category_id: 108 },
  { value: 22, label: "General Appointments", category_id: 112 },
  { value: 23, label: "Miscellaneous Classified", category_id: 116 },
  { value: 24, label: "School Education", category_id: 106 },
  { value: 25, label: "Mutual Funds", category_id: 117 },
  { value: 26, label: "Education Recruitments", category_id: 112 },
  { value: 27, label: "Services", category_id: 118 },
  { value: 28, label: "Real Estate", category_id: 119 },
  { value: 29, label: "Exhibition ads", category_id: 120 },
  { value: 30, label: "Poultry", category_id: 121 },
  { value: 31, label: "Tenders State Govt", category_id: 111 },
  { value: 32, label: "Private Tenders", category_id: 107 },
  { value: 33, label: "Hospitals", category_id: 114 },
  { value: 34, label: "Health Care/Hospitals", category_id: 112 },
  { value: 35, label: "Appointment State Govt", category_id: 111 },
  { value: 36, label: "NOTICE (DEMAND/ SALE/AUCTION)", category_id: 122 },
  { value: 37, label: "DISPLAY Central GOVT", category_id: 111 },
  { value: 38, label: "ONLINE/ EDU TECH", category_id: 106 },
  { value: 39, label: "Retirement", category_id: 108 },
  { value: 40, label: "HOSPITAL ANNIVERSARIES", category_id: 114 },
  { value: 41, label: "Housewarming", category_id: 108 },
  { value: 46, label: "ANNIVERSARIES", category_id: 133 }
];
export const orderPaymentTypes = [
  {
    label: "Cashfree",
    value: 1,
  },
  {
    label: "Cheque",
    value: 2,
  },
  {
    label: "Cash",
    value: 3,
  },
  {
    label:"IMPS/NEFT/RTGS",
    value: 4
  },
  {
    label: "Invoice",
    value: 5,
  },
  {
    label: "Cashfree Order",
    value: 6
  },
  {
    // booked by finance when the TDS withheld on a transaction is received from the government
    label: "TDS",
    value: 7
  }
];

// accepted upload types for the TDS proof finance attaches when marking TDS as
// received — certificates come in as a scan or a PDF
export const TDS_PROOF_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/webp", "application/pdf"];

export const getFirstKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};
export const positionalPriceReferences = [{label: 'Local Card Lists', value: 'local_ads_positional_price'}, {label: 'Alpha Card Lists', value: 'alpha_ads_panel_positional_price'}, {label: 'Classified Card Lists', value: 'classified_ads_positional_price'}, 
{label: "Local Package Card Lists", value: 'local_package_panel_positional_price'},  {label: 'Zone Card Lists', value: 'zone_package_positional_price'}]

export const BACKFILL_GAM_INTERNAL_OPTIONS = [
  // { label: "Astro", value: "astro" },
  { label: "Job Listings", value: "job_listings" },
  { label: "Business Listings", value: "business_listings" },
  { label: "Specials", value: "specials" },
  { label: "Classifieds", value: "classifieds" },
];

export const BACKFILL_GAM_PAGE_OPTIONS = [
  { value: '1', label: 'Full' },
  { value: '2', label: 'Half GAM' },
  { value: '3', label: 'Half Rec' },
];

export const getBackfillGamPageOptions = (widgetType) => {
  if (widgetType === 'specials') {
    return BACKFILL_GAM_PAGE_OPTIONS.filter(option => option.value !== '1');
  }
  if( widgetType === 'classifieds') {
    return BACKFILL_GAM_PAGE_OPTIONS.filter(option => option.value === '1');
  }
  return BACKFILL_GAM_PAGE_OPTIONS;
};

export const normalizeBackfillGamPage = (widgetType, page) => {
  const options = getBackfillGamPageOptions(widgetType);
  const defaultValue = options.some(option => option.value === '3') ? '3' : options[0]?.value || '3';
  const pageValue = String(page || defaultValue);
  return options.some(option => option.value === pageValue) ? pageValue : defaultValue;
};

export const getBackfillGamPageLabel = (page, widgetType) => {
  const pageValue = normalizeBackfillGamPage(widgetType, page);
  return BACKFILL_GAM_PAGE_OPTIONS.find(option => option.value === pageValue)?.label || 'Full';
};
export const isOnly300x250 = (sizeStr) => {
  if (!sizeStr) return true; // empty / null is allowed
  return sizeStr
    .split(',')
    .map(s => s.trim())
    .some(size => size === '300x250');
};

export const getDefaultDateRange = (last = 0) => {
  const end = new Date();
  const start = new Date();
  if(last) {
     start.setFullYear(start.getFullYear()-1);
     end.setFullYear(end.getFullYear()-1);
  }
  start.setDate(1);
  end.setDate(1);
  return [start, end];
};

export const getDayKey = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDisplayDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });


export const formatTimestamp = (timestamp = Math.floor(Date.now() / 1000)) => 
  new Date(timestamp * 1000).toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });



  export const click_navigation_options = [
     {label: "Buzz", value: "2"},
     {label: "Compose", value: "3"},
     {label: "Local", value: "4"},
     {label: "Videos", value: "5"},
     {label: "Magazines", value: "6"},
     {label: "Post", value: "post"},
    { label: "Language Change", value: "7"},
    { label: "Jobs", value: "8" },
    { label: "Contest", value: "9" },
    { label: "Subscription", value: "12" }
  ]

   export const getOverlapStatus = (status) => {
    switch (status) {
      case 2:
        return { label: "Running", bg: "#c8e6c9", color: "#1b5e20", fontSize: "1rem" };
      case 3:
        return { label: "Paused", bg: "#bbdefb", color: "#0d47a1", fontSize: "1rem" };
      case 5:
        return { label: "Scheduled", bg: "#e0e0e0", color: "#424242", fontSize: "1rem" };
      default:
        return { label: "Unknown", bg: "#eeeeee", color: "#616161", fontSize: "1rem" };
    }
  };